$(document).ready(function()
{
    $('#open-template-preview').on('click', function(e)
    {
        $('.responsive-template-view').stop().fadeIn(200);
        $('body').css({'overflow':'hidden'});
    });

    $('.responsive-template-view').on('click', function(e)
    {
        if($(e.target).attr('class').search('responsive-template-view') === 0)
        {
            $('body').css({'overflow':'initial'});
            $('.responsive-template-view').stop().fadeOut(200);
        }
    });

    $('.nav-button').on('mouseover', function()
    {
        $(this).find('.nav-text-hidden').stop().fadeIn(200);
    });

    $('.nav-button').on('mouseout', function()
    {
        $(this).find('.nav-text-hidden').stop().fadeOut(200);
    });

    $('.nav-button').on('click', function()
    {
        if($(this).hasClass('popup-close'))
        {
            $('.responsive-template-view').stop().fadeOut(200);
            $('body').css({'overflow':'initial'});
            return;
        }

        $('.responsive-template-view').find('.nav-button').each(function()
        {
            $(this).removeClass('active');
        });

        $(this).addClass('active');

        var view = $(this).attr('data-view');
        $("#template-view-iframe").fadeOut(200, function()
        {
            $("#template-view-iframe").removeClass();
            $("#template-view-iframe").addClass(view);
        }).fadeIn(200);

    });

});